{
  "error": "Virhe",
  "help": "Ohje",
  "info": "Tiedot",
  "success": "Onnistui",
  "warning": "Varoitus"
}
